var _g, _defs;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCircularArrow = function SvgCircularArrow(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 102,
    viewBox: "0 0 120 102",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_140_9944)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.8911 47.7219H45.0511C45.7866 47.7219 46.1552 46.8326 45.6351 46.3125L33.5225 34.201C33.1994 33.8779 32.677 33.8779 32.3551 34.201L20.2435 46.3125C19.7234 46.8326 20.0915 47.7219 20.8275 47.7219H29.0468C29.3238 65.0359 43.8735 78.944 61.4234 78.1523C61.8628 78.1327 62.2095 77.7624 62.2101 77.3223L62.2239 71.0959C62.2245 70.6104 61.8087 70.2406 61.3249 70.2757C47.9826 71.2606 37.1725 60.8124 36.8909 47.7231L36.8911 47.7219ZM58.5753 16.0323C58.137 16.0519 57.7909 16.4211 57.7886 16.8594L57.7586 23.0583C57.7563 23.5444 58.1721 23.9164 58.6571 23.8795C71.9999 22.8987 82.8301 33.3717 83.1087 46.4616H74.9487C74.2133 46.4616 73.8447 47.3509 74.3647 47.871L86.4773 59.9842C86.8004 60.3073 87.3228 60.3073 87.6448 59.9842L99.7563 47.8726C100.276 47.3525 99.9084 46.4633 99.1723 46.4633H90.9531C90.676 29.1478 76.1252 15.2391 58.5753 16.0323Z",
    fill: "url(#paint0_linear_140_9944)",
    shapeRendering: "crispEdges"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_140_9944",
    x: 0.627693,
    y: 0.502155,
    width: 118.744,
    height: 100.929,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.87446
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 9.68615
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_140_9944"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_140_9944",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_140_9944",
    x1: 99.9998,
    y1: 53.7549,
    x2: 23.8928,
    y2: 22.3104,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#075FF7",
    stopOpacity: 0.49
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#82B0FF",
    stopOpacity: 0.19
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCircularArrow, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/CircularArrow.77bd39cd.svg";
export { ForwardRef as ReactComponent };